import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useState, useEffect, useRef } from 'react';
import apis from '../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import TimePicker from '../TimePicker/TimePicker';
import { Toolbar } from 'primereact/toolbar';
import { excelExport } from '../../services/excelExport.service';
import { excelReport } from '../../services/excelReport.service';
import { FileUpload } from 'primereact/fileupload';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';

const ApprovalConf = () => {
    const [flows, setFlows] = useState([])
    const [contractList, setContractList] = useState([])
    const [approverList, setApproverList] = useState([])
    const [noveltyList, setNoveltyList] = useState([])

    const [loadPage, setLoadPage] = useState(false);
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading5, setLoading5] = useState(false)
    const [loading6, setLoading6] = useState(false)
    const [isOpenFlow, setIsOpenFlow] = useState(false)
    const [isOpenFlowUpdate, setIsOpenFlowUpdate] = useState(false)
    const [isOpenFlowDelete, setIsOpenFlowDelete] = useState(false)

    const headers = { Authorization: localStorage.getItem("token") }
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    const [approverId, setApproverId] = useState("")
    const [contract, setContract] = useState("")
    const [approverGroup, setApproverGroup] = useState("")
    const [noveltyType, setNoveltyType] = useState("")

    const [loadingExport, setLoadingExport] = useState(false);
    const [exportContent, setExportContent] = useState([])
    const [isOpenCargue, setIsOpenCargue] = useState(false);
    const fileUploadRef = useRef(null);
    const [consultado, setConsultado] = useState(false);
    

    const toast = useRef(null);

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [flowSelected, setFlowSelected] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    useEffect(() => {
        getApproverList()
        getApproverFlow()
    }, [])

    const hideModalFlow = () => {
        setContract("")
        setApproverGroup("")
        setNoveltyType("")
        setIsOpenFlow(false)
    }

    const hideModalFlowUpdate = () => {
        setContract("")
        setApproverGroup("")
        setNoveltyType("")
        setApproverId("")
        setIsOpenFlowUpdate(false)
    }

    const hideModalFlowDelete = () => {
        setContract("")
        setApproverGroup("")
        setNoveltyType("")
        setApproverId("")
        setIsOpenFlowDelete(false)
    }

    const showModalCargue = () => {
        setIsOpenCargue(true);
    };

    const hideModalCargue = () => {
        setIsOpenCargue(false);
    };

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                </IconField>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];
    
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 }
            ];

            return (
            <React.Fragment>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
            </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const getApproverList = async () => {
        try{
            await apis.approverFlowConfList(entity, client, headers).then(res => { 
                setContractList(res.data.CONTRACTS)
                setApproverList(res.data.MASTER_GR_APROVER)
            })
        }
        catch(error){
            console.log(error)
        }
    }

    const getApproverFlow = async () => {
        setLoadPage(false)
        try{
            await apis.getApproverFlowConf(entity, client, headers).then(res => {
                let data = []
                let exportData = []
                res.data.FLOW_CONTRACT.forEach(flow => {
                    const noveltyType_ = flow.APPROVAL_NOVELTY.split('|')
                    const contract_ = flow.CONTRACT_ID.split('|')
                    const group_ = flow.GROUP_ID.split('|')
                    let newFlow = {
                        ...flow,
                        APPROVAL_NOVELTY: noveltyType_[0],
                        APPROVAL_NOVELTY_DESC: noveltyType_[1],
                        CONTRACT_ID: contract_[0],
                        CONTRACT_ID_DESC: contract_[1],
                        GROUP_ID: group_[0],
                        GROUP_ID_DESC: group_[1],
                    }
                    let newExport = {
                        ID: flow.APPROV_CONFIG_ID,
                        Grupo: group_[1],
                        'Tipo novedad': noveltyType_[1],
                        Contrato: contract_[0],
                        Nombre: contract_[1]
                    }
                    data.push(newFlow)
                    exportData.push(newExport)
                    
                })
                console.log(data)
                setExportContent(exportData)
                setFlows(data)
            })
        }
        catch(error){
            console.log(error)
        }
        finally{
            setLoadPage(true)
        }
    }

    const postApproverFlow = async () => {
        setLoading1(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                APPROVAL_NOVELTY: noveltyType.GROUP_APPROV_ID,
                GROUP_ID: approverGroup.GROUP_ID,
                CONTRACT_ID: contract.CODE,
            }
            await apis.postApproverFlowConf(payload, headers).then(res => {
                getApproverFlow()
                hideModalFlow()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Configuración flujo de aprobadores creada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading1(false)
        }
    }

    const putApproverFlow = async () => {
        setLoading2(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                APPROV_CONFIG_ID: approverId,
                APPROVAL_NOVELTY: noveltyType.GROUP_APPROV_ID,
                GROUP_ID: approverGroup.GROUP_ID,
                CONTRACT_ID: contract.CODE,
            }
            await apis.putApproverFlowConf(payload, headers).then(res => {
                getApproverFlow()
                hideModalFlowUpdate()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Configuración flujo de aprobadores actualizada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading2(false)
        }
    }

    const deleteApproverFlow = async () => {
        setLoading3(true)
        try{
            await apis.delApproverFlowConf(entity, client, approverId, headers).then(res => {
                getApproverFlow()
                hideModalFlowDelete()
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: "Configuración flujo de aprobadores eliminada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading3(false)
        }
    }

    const setFlowData = (rowData) => {
        const contract_ = contractList.filter(cont => cont.CODE === rowData.CONTRACT_ID)[0]
        const approverGroup_ = approverList.filter(app => app.GROUP_ID === rowData.GROUP_ID)[0]
        setNoveltyList(approverGroup_?.DETAIL_GR_APROVER)
        const noveltyType_ = approverGroup_?.DETAIL_GR_APROVER.filter(nov => nov.GROUP_APPROV_ID === rowData.APPROVAL_NOVELTY)[0]
        console.log(rowData)
        setApproverId(rowData.APPROV_CONFIG_ID)
        setContract(contract_)
        setApproverGroup(approverGroup_)
        setNoveltyType(noveltyType_)
        setIsOpenFlowUpdate(true)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm text-xs" onClick={() => setFlowData(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-danger p-button-sm text-xs" onClick={() => {setApproverId(rowData.APPROV_CONFIG_ID); setIsOpenFlowDelete(true)}}/>
            </div>
        )
    }

    const addFlowFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalFlow() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => postApproverFlow()} disabled={!contract || !approverGroup || !noveltyType}/>
        </div>
    );

    const addFlowHeader = (
        <div>
            <h3>Agregar configuración flujo de aprobadores</h3>
        </div>
    )

    const updateFlowFooter = (
        <div>
            <Button onClick={() => { setLoading2(false); hideModalFlowUpdate() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading2} onClick={() => putApproverFlow()} disabled={!contract || !approverGroup || !noveltyType}/>
        </div>
    );

    const updateShiftHeader = (
        <div>
            <h3>Editar configuración flujo de aprobadores</h3>
        </div>
    )

    const deleteShiftFooter = (
        <div>
            <Button onClick={() => { setLoading3(false); hideModalFlowDelete() }}>Cancelar</Button>
            <Button className="p-button-danger" label="Eliminar" loading={loading3} onClick={() => deleteApproverFlow()} />
        </div>
    );

    const deleteFlowHeader = (
        <div>
            <h3>¿Desea eliminar la configuración de flujo de aprobadores?</h3>
        </div>
    )

    const msgContent = (
        <div>
            <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
            {process.env.REACT_APP_DISABLE_MSG}
            </a>
        </div>
    )

    const handlegroupList = (value) => {
        setApproverGroup(value)
        setNoveltyType("")
        setNoveltyList(value?.DETAIL_GR_APROVER)
    }

    const exportExcel = () => {
        try{
            excelExport(exportContent, 'ConfiguracionFlujoAprobadores')
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error al exportar", sticky: true });
        }
        finally{
            setLoadingExport(false);
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-plus" label="Agregar" className="p-button-success p-button-sm " onClick={() => setIsOpenFlow(true)}/>
                <Button label="Cargue" icon="pi pi-upload" className="p-button-success mr-2 p-button-sm" onClick={showModalCargue} />
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
          <React.Fragment>
            <Button label="Exportar" icon="pi pi-file-excel" tooltip='Exportar información de la tabla' loading={loadingExport}
                tooltipOptions={{ position: 'top' }} className="p-button-success mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
          </React.Fragment>
        )
    }

    async function downloadSampleFile() {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.uploadApproverFlowConf(payload, headers).then(res => {
                sampleFile = res.data
                let nombre = sampleFile["SHEETS"][0]["NAME"]
                excelReport(sampleFile, nombre)
                setLoading5(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading5(false)
        }
    }

    async function loadError(lines) {
        /*Función encargada de generar el archivo txt de errores del cargue*/
        const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        saveAs(blob, "ErroresCargue.txt");
    }

    async function importData(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.uploadApproverFlowConf(_importedData, headers).then(res => {
                setConsultado(false)
                toast.current.clear()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
                hideModalCargue()
                getApproverFlow()
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado(false)
            toast.current.clear()
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    const showConfirm = () => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'info', sticky: true, content: (
            <div className="flex flex-column" style={{ flex: '1' }}>
                <div className="text-center">
                    <i >
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
                    </i>
                    <p>Cargando información...</p>
                </div>
            </div>
            )
        });
    }

    async function importCargue(e) {
        /*Función encargada de formatear los datos del archivo Excel para subirlos*/
        setConsultado(true);
        showConfirm();
        const file = e.files[0];

        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

                // Prepare DataTable
                data.shift();

                let _importedData = {
                    CLIENT: localStorage.getItem('client'),
                    ENTITY: localStorage.getItem('entity'),
                    OPTION: 1,
                    DETAIL: []
                }

                let lines = 1
                data.forEach(row => {
                    let _line = ""
                    row.forEach(element => {
                        _line += element + "|"
                    })
                    _line = _line.slice(0, -1)
                    _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                    lines++
                })

                importData(_importedData)
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const footerCargue = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading5(false); setLoading6(false); hideModalCargue() }} />
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFile() }} />
            <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
            </FileUpload>
        </div>
    );

    const headerCargue = (
        <div>
            <h3>Cargar configuración flujo de aprobadores</h3>
        </div>
    )

    return(
        <div className="flex flex-wrap align-items-center justify-content-center flex-column align-self-center">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Dialog header={addFlowHeader} footer={addFlowFooter} visible={isOpenFlow}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalFlow}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Grupo</label>
                    <Dropdown filter showClear filterBy="NAME,COD_GROUP" optionLabel='NAME' placeholder="Grupo" value={approverGroup} options={approverList} onChange={(e) => handlegroupList(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Tipo novedad</label>
                    <Dropdown filter showClear disabled={!approverGroup} filterBy="APPROVAL_NOVELTY" optionLabel='APPROVAL_NOVELTY' placeholder="Tipo novedad" value={noveltyType} options={noveltyList} onChange={(e) => setNoveltyType(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Contrato</label>
                    <Dropdown filter showClear filterBy="NAME" optionLabel='NAME' placeholder="Contrato" value={contract} options={contractList} onChange={(e) => setContract(e.value)} />
                </div>
            </Dialog>
            <Dialog header={updateShiftHeader} footer={updateFlowFooter} visible={isOpenFlowUpdate}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalFlowUpdate}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID configuración</label>
                    <InputText value={approverId} placeholder="ID aprobador" className="p-inputtext-sm" disabled={true}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Grupo</label>
                    <Dropdown filter showClear filterBy="NAME,COD_GROUP" optionLabel='NAME' placeholder="Grupo" value={approverGroup} options={approverList} onChange={(e) => handlegroupList(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Tipo novedad</label>
                    <Dropdown filter showClear disabled={!approverGroup} filterBy="APPROVAL_NOVELTY" optionLabel='APPROVAL_NOVELTY' placeholder="Tipo novedad" value={noveltyType} options={noveltyList} onChange={(e) => setNoveltyType(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Contrato</label>
                    <Dropdown filter showClear filterBy="NAME" optionLabel='NAME' placeholder="Contrato" value={contract} options={contractList} onChange={(e) => setContract(e.value)} />
                </div>
            </Dialog>
            <Dialog header={deleteFlowHeader} footer={deleteShiftFooter} visible={isOpenFlowDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalFlowDelete}>
            </Dialog>
            <Dialog header={headerCargue} footer={footerCargue} visible={isOpenCargue}
                position="top" style={{ width: "28rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja UploadFlow_group_approvers, teniendo en cuenta las instrucciones de la hoja Instructivo.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <span className="text-900">Configuración Flujo de Aprobadores</span>
            </div>
            {localStorage.getItem('tracking') === 'N' && localStorage.getItem('novelties') === 'N' ?
                <div className='flex justify-content-center'>
                    <Card style={{ width: "60%" }}>
                        <Message severity="info"
                        style={{
                            width: "100%",
                            fontSize: "18px",
                            border: 'solid #696cff',
                            borderWidth: '2px',
                            color: '#696cff'
                        }}
                        content={msgContent}
                        />
                    </Card>
                </div>:
                <div className="card mt-4 w-9">
                    <SkeletonTable load={loadPage}>
                        <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} />
                        <DataTable className="text-xs" value={flows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={flowSelected} onSelectionChange={(e) => setFlowSelected(e.value)} dataKey="APPROV_CONFIG_ID" selectionMode={"single"}
                            size="small" filters={filters1} filterDisplay="menu" header={header1} 
                            globalFilterFields={['APPROV_CONFIG_ID', 'GROUP_ID_DESC', 'APPROVAL_NOVELTY_DESC', 'CONTRACT_ID', 'CONTRACT_ID_DESC']}
                        >
                            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                            <Column field="APPROV_CONFIG_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                            <Column field="GROUP_ID_DESC" header="Grupo" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Grupo" sortable></Column>
                            <Column field="APPROVAL_NOVELTY_DESC" header="Tipo novedad" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo novedad" sortable></Column>
                            <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
                            <Column field="CONTRACT_ID_DESC" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                            <Column header="Acciones" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                        </DataTable>
                    </SkeletonTable>
                </div>
                }
        </div>
    )
}

export default ApprovalConf
